/**
 * The chevron-expanded detail strip: labeled config facts, the master
 * config it follows (every container follows its campaign group's —
 * Phase 20), Duplicate. Absent pairs are simply omitted — the strip is a
 * flex-wrap list.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenMasterSummary } from '@trafficpulse/shared';

import type { DropGenContainerSummary } from '../../drop-generator.types';

const FACT_LABEL = 'text-[9.5px] font-semibold uppercase tracking-wider text-muted-foreground';

export interface DetailStripProps {
  dropsSpec: string;
  campaignName: string;
  /** The master config it follows (its campaign group's). */
  master: DropGenMasterSummary | null;
}

const Fact: FC<{ label: string; children: React.ReactNode; mono?: boolean }> = ({ label, children, mono }) => (
  <div className="min-w-0">
    <div className={FACT_LABEL}>{label}</div>
    <div className={mono ? 'font-mono text-xs tabular-nums' : 'text-xs'}>{children}</div>
  </div>
);

export const ContainerDetailStrip: FC<DetailStripProps & { container: DropGenContainerSummary }> = (p) => (
  <div className="flex flex-wrap items-end gap-x-8 gap-y-3 border-b border-border/40 bg-muted/20 py-3 pl-[62px] pr-6">
    <Fact label="Drops">{p.dropsSpec}</Fact>
    <Fact label="Campaign">{p.campaignName}</Fact>
    <Fact label="Master config">{p.master ? `follows ${p.master.name}` : '—'}</Fact>
    <Fact label="Groups">
      {p.container.groupCount > 0 ? `${p.container.groupCount} linked · open the editor to see them` : 'none yet'}
    </Fact>
    <Fact label="Mid-day fail">{p.container.failMode === 'STOP_FOR_DAY' ? 'stop list' : 'complete list'}</Fact>
  </div>
);
